import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ onOpenForm }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Disable body scroll when menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const navLinks = [
    { to: '/ultimate', label: 'ULTIMATE' },
    { to: '/equipa', label: 'EQUIPA' },
    { to: '/personal-training', label: 'PERSONAL TRAINING' },
    { to: '/aulas', label: 'AULAS' },
    { to: '/contactos', label: 'CONTACTOS' }
  ];

  const handleLogoClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    // If on another page, let the Link navigate normally
  };

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-black shadow-2xl' : 'bg-transparent'
        }`}
      >
        <div className="w-full px-[20px] md:px-[60px]">
          <div className="flex items-center justify-between h-20">
            {/* Logo - Mobile: 20% menor e mais à esquerda */}
            <Link 
              to="/" 
              className="flex items-center relative z-50 transition-all duration-300 hover:opacity-90 cursor-pointer"
              onClick={handleLogoClick}
              style={{ paddingLeft: "0px" }}
            >
              <img 
                src="/assets/logo-uf.png?v=2" 
                alt="Ultimate Fit" 
                className="h-10 md:h-14 lg:h-16 w-auto object-contain brightness-0 invert"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-7">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-white hover:text-yellow-400 transition-colors duration-200"
                  style={{ fontFamily: "'BebasNeue-Book', sans-serif", fontWeight: "normal", fontSize: "27px" }}
                >
                  {link.label}
                </Link>
              ))}
              <Button
                onClick={onOpenForm}
                className="bg-yellow-400 hover:bg-yellow-500 text-black px-8 py-2 border-2 border-yellow-400 hover:border-yellow-500 transition-all hover:shadow-xl transform hover:-translate-y-0.5"
                style={{ fontFamily: "'BebasNeue-Book', sans-serif", fontWeight: "normal", fontSize: "28px", letterSpacing: "1.5px", textTransform: "uppercase" }}
              >
                COMEÇAR A TREINAR
              </Button>
            </nav>

            {/* Mobile Menu Button - 20% menor */}
            <button
              className="lg:hidden text-white relative z-50"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>
      </header>

      {/* Full Screen Mobile Menu */}
      <div
        className={`fixed inset-0 bg-black/80 backdrop-blur-sm z-40 lg:hidden transition-transform duration-500 ease-in-out ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="relative flex flex-col h-full items-center justify-center px-6">
          {/* Menu Links - Centered */}
          <nav className="flex flex-col items-center space-y-7">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-white hover:text-yellow-400 active:opacity-70 transition-all duration-200 tracking-wide text-center"
                style={{ fontFamily: "'BebasNeue-Book', sans-serif", fontWeight: "normal", fontSize: "38px", lineHeight: "1" }}
                onClick={handleNavClick}
              >
                {link.label}
              </Link>
            ))}

            {/* CTA logo abaixo de Contactos */}
            <Button
              onClick={() => {
                onOpenForm();
                handleNavClick();
              }}
              data-testid="mobile-menu-cta-btn"
              className="bg-yellow-400 hover:bg-yellow-500 active:bg-yellow-600 text-black px-10 py-6 border-2 border-yellow-400 hover:border-yellow-500 transition-all mt-4"
              style={{ fontFamily: "'BebasNeue-Book', sans-serif", fontWeight: "normal", fontSize: "26px", letterSpacing: "-0.02em" }}
            >
              MARCAR AVALIAÇÃO FÍSICA GRATUITA
            </Button>
          </nav>

          {/* Copyright */}
          <p className="absolute bottom-8 left-0 right-0 text-gray-500 text-center text-xs" style={{ fontFamily: "'BebasNeue-Book', sans-serif", fontWeight: "normal" }}>
            © {new Date().getFullYear()} Ultimate Fit
          </p>
        </div>
      </div>
    </>
  );
};

export default Header;